import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';
import { convertLocalEpochToUTC } from '../../util/timezone';

export const fetchDashboardBins = async () => {
  const response = await axios.get(`${CM_BASE_URL}/configs/client`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch client config' };
  }

  return response.data;
};

export const fetchTotalPendingAlerts = async ({ filters }) => {
  const params = {
    from: convertLocalEpochToUTC(filters.from),
    to: convertLocalEpochToUTC(filters.to)
  };
  const response = await axios.get(`${CM_BASE_URL}/alerts/total-pending`, {
    params
  });

  if (response.status !== 200) {
    throw { message: 'Failed to fetch pending alerts statistics' };
  }

  return response.data;
};

export const fetchCaseAgingStats = async ({ filters, caseAgingBins }) => {
  const requestBody = { ageingBins: caseAgingBins };
  const params = {
    from: convertLocalEpochToUTC(filters.from),
    to: convertLocalEpochToUTC(filters.to)
  };
  const url = `${CM_BASE_URL}/cases/caseAgingStats`;

  return axios.post(url, requestBody, { params }).then((res) => {
    if (res.status !== 200 && res.data.status !== 'success') {
      throw { message: 'Failed to fetch case aging statistics' };
    }
    return res.data;
  });
};
